/**
 * Cams API
 * Cams
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface MemberFinancialReconcileResonse { 
    loanFeededValueSum?: number;
    savingAccFeededValueSum?: number;
    shareAccFeededValueSum?: number;
    currentAccFeededValueSum?: number;
    loanBookValueSum?: number;
    savingAccBookValueSum?: number;
    shareAccBookValueSum?: number;
    currentAccBookValueSum?: number;
    chargesAmountSum?: number;
}

